/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ImportSegmentIn {
  speaker: string;
  /** @minLength 1 */
  text: string;
  start_ms?: number | null;
  end_ms?: number | null;
}
